import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { get, isEmpty, isEqual, map, filter, find, cloneDeep } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';

import {
  Box,
  Button,
  IconButton,
  InputLabel,
  Modal,
  Menu,
  MenuItem,
  Paper,
  Stack,
  styled,
  Switch,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from '@mui/material';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import PauseCircleOutlineRoundedIcon from '@mui/icons-material/PauseCircleOutlineRounded';
import PlaceIcon from '@mui/icons-material/Place';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import SettingsIcon from '@mui/icons-material/Settings';
import StreetviewIcon from '@mui/icons-material/Streetview';
import SwitchVideoIcon from '@mui/icons-material/SwitchVideo';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';

import { exportTextToLocalFile } from '../../../modules/export-import-files';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

import * as annotationOps from '../../../api/Annotations/annotation-operations';
import Loading from '../Loading';
import TableContent from '../TableContent';

import * as videoOps from '../../../api/Videos/video-operations';
import * as videoCalculate from '../../../api/Videos/videos-calculations';
import useTimeStore from '../ZustandProvider';

const HEADER_HEIGHT = 74; // When it is all in the same line
const PAGINATION_HEIGHT = 46;
const CELL_HEIGHT = 49;

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#757575',
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));

class AnnotationsMapsTable extends Component {
  annotationDiv = React.createRef();

  tableElement = React.createRef();

  StyledTextField = {
    color: 'white'
  };

  state = {
    annotationByTemplate: [],
    anchorEl: null,
    openMenuByTemplate: false,
    openMenuOneByGPS: false,
    openMenuAllbyGPS: false,
    anchorElExport: null,
    anchorElImport: null,
    anchorElVideos: null,
    presentPlay: false,
    timePresent: 0,
    isTimeEditor: true,
    openModalGeomotion: false,
    openModalGeomotionPublic: false,
    openModalProfile: false
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
    this.handleTypesTemplate();
    this.startCenterNotesDefault();
  }

  componentDidUpdate(prevProps) {
    const { annotations, videoSelected } = this.props;
    const { videoSelected: prevVideoSelected } = prevProps;
    const { presentPlay, intervalID } = this.state;

    if (presentPlay === false) clearInterval(intervalID);

    if (!isEqual(videoSelected, prevVideoSelected) && !isEmpty(annotations)) {
      this.handleTypesTemplate();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  startCenterNotesDefault = () => {
    const { notesProps } = this.props;
    if (notesProps.centerNotesDefault === true) {
      useTimeStore.setState({ checkCenterAnnotation: true });
    } else {
      useTimeStore.setState({ checkCenterAnnotation: false });
    }
  };

  updateDimensions = () => {
    const height =
      get(this, 'tableElement.current.offsetHeight', 500) - (PAGINATION_HEIGHT + HEADER_HEIGHT);
    let itemsPerPage = Math.floor(height / CELL_HEIGHT);
    if (itemsPerPage < 1) itemsPerPage = 1;
  };

  handleAnnotationLeft = () => {
    const { annotations, count, handleSelectAnnotation } = this.props;
    if (count > 0) {
      const newCount = count - 1;
      const selectedAnnotation = annotations[newCount];
      handleSelectAnnotation(selectedAnnotation, newCount);
    }
  };

  handleAnnotationRight = () => {
    const { annotations, count, handleSelectAnnotation, totalCountAnnotations } = this.props;
    const annotationLenght = totalCountAnnotations - 1;
    if (count < annotationLenght) {
      const newCount = count + 1;
      const selectedAnnotation = annotations[newCount];
      handleSelectAnnotation(selectedAnnotation, newCount);
    }
  };

  handleCenterCheck = event => {
    const { checked } = event.target;
    useTimeStore.setState({ checkCenterAnnotation: checked });
  };

  handleCloseProfile = () => {
    this.setState({ openModalProfile: false });
  };

  handleCloseSettings = () => {
    this.setState({
      anchorEl: null,
      anchorElExport: null,
      anchorElImport: null,
      openMenuByTemplate: false
    });
  };

  handleCloseSettingsByTemplates = () => {
    this.setState({ openMenuByTemplate: false });
  };

  handleCloseSettingsExport = () => {
    this.setState({ anchorElExport: null });
  };

  handleCloseSettingsImport = () => {
    this.setState({ anchorElImport: null });
  };

  handleCloseMenuVideos = () => {
    this.setState({ anchorElVideos: null });
  };

  handleEndAnnotation = () => {
    const { totalCountAnnotations, annotations, handleSelectAnnotation } = this.props;
    const annotationLenght = totalCountAnnotations - 1;
    const selectedAnnotation = annotations[annotationLenght];
    handleSelectAnnotation(selectedAnnotation, annotationLenght);
  };

  handleExport = async (video, method, syncGPS = false) => {
    const { selectedAnnotation, annotations } = this.props;
    const videoTemplates = videoOps.getAnnotationTemplates(video);
    const namesTemplates = videoTemplates.map(element => element.name);
    try {
      if (method === 'actualAnnotation') {
        const exportItem = cloneDeep(selectedAnnotation);
        if (syncGPS) {
          const newTimeGPS = videoCalculate.calculateTimeGPSAnnotation(video, exportItem);
          exportItem.timeGPS = newTimeGPS;
        }
        const nameFile = !syncGPS
          ? `${videoOps.getName(video)}_annotation.json`
          : `${videoOps.getName(video)}_GPS_annotation.json`;
        exportTextToLocalFile(nameFile, JSON.stringify({ annotations: [exportItem] }, null, '  '));
      } else if (method === 'annotations') {
        const exportItem = await methodPromise('videos.exportAnnotations', videoOps.getId(video));
        if (syncGPS) {
          const newAnnotations = map(exportItem.annotations, element => {
            const item = element;
            const newTimeGPS = videoCalculate.calculateTimeGPSAnnotation(video, item);
            item.timeGPS = newTimeGPS;
            return item;
          });
          const exportItemGPS = { annotations: newAnnotations };
          exportTextToLocalFile(
            `${videoOps.getName(video)}_GPS_annotations.json`,
            JSON.stringify(exportItemGPS, null, '  ')
          );
        } else {
          exportTextToLocalFile(
            `${videoOps.getName(video)}_annotations.json`,
            JSON.stringify(exportItem, null, '  ')
          );
        }
      } else if (method === 'video') {
        exportTextToLocalFile(`${videoOps.getName(video)}.json`, JSON.stringify(video, null, '  '));
      } else if (namesTemplates.includes(method)) {
        const annotationByTemplate = filter(annotations, element => {
          const template = annotationOps.getTemplate(element);
          return template.name === method;
        });
        exportTextToLocalFile(
          `${videoOps.getName(video)}_${method}.json`,
          JSON.stringify(annotationByTemplate, null, '  ')
        );
      }
      this.setState({ anchorEl: null, anchorElExport: null, openMenuByTemplate: false });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleHardRemove = async () => {
    const { videoSelected, handleManyDeleteAnnotations } = this.props;
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure? This is permanent!')) {
      try {
        const videoId = videoOps.getId(videoSelected);
        await methodPromise('annotations.hardManyDelete', videoId);
        handleManyDeleteAnnotations(true);
        Bert.alert(`Anotaciones borradas!`, 'danger');
      } catch (error) {
        handleErrorInClient(error);
      }
    }
  };

  handleMenuSettings = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuOneByGPS = value => {
    this.setState({ openMenuOneByGPS: value });
  };

  handleMenuAllByGPS = value => {
    this.setState({ openMenuAllbyGPS: value });
  };

  handleMenuByTemplate = value => {
    this.setState({ openMenuByTemplate: value });
  };

  handleMenuExport = event => {
    this.setState({ anchorElExport: event.currentTarget });
  };

  handleMenuImport = event => {
    this.setState({ anchorElImport: event.currentTarget });
  };

  handleMenuVideos = event => {
    this.setState({ anchorElVideos: event.currentTarget });
  };

  handleOpenGeomotion = () => {
    const { openModalGeomotion } = this.state;
    this.setState({ openModalGeomotion: !openModalGeomotion });
  };

  handleOpenGeomotionPublic = () => {
    const { openModalGeomotionPublic } = this.state;
    this.setState({ openModalGeomotionPublic: !openModalGeomotionPublic });
  };

  handleOpenProfile = async () => {
    this.setState({ openModalProfile: true });
  };

  handleStartAnnotation = () => {
    const { annotations, handleSelectAnnotation } = this.props;
    const selectedAnnotation = annotations[0];
    handleSelectAnnotation(selectedAnnotation, 0);
  };

  handleTypesTemplate = () => {
    const { annotations } = this.props;
    const templateArray = [];
    map(annotations, element => {
      const template = annotationOps.getTemplate(element);
      if (!templateArray.includes(template.name)) templateArray.push(template.name);
    });
    this.setState({ annotationByTemplate: templateArray });
  };

  handleTimePresentation = event => {
    const { value } = event.target;
    this.setState({ timePresent: value, isTimeEditor: false });
  };

  playPresentation = () => {
    const { presentPlay } = this.state;
    this.setState({ presentPlay: !presentPlay });
    if (!presentPlay === true) this.presentAnnotation();
  };

  presentAnnotation = () => {
    const { totalCountAnnotations, notesProps } = this.props;
    const { isTimeEditor, timePresent } = this.state;
    const timeInterval = isTimeEditor ? notesProps.interval.value * 1e3 : timePresent * 1e3;
    const annotationLenght = totalCountAnnotations - 1;
    const interval = setInterval(() => {
      const { count } = this.props;
      if (count === annotationLenght) this.handleStartAnnotation();
      else this.handleAnnotationRight();
    }, timeInterval);
    this.setState({ intervalID: interval });
  };

  render() {
    const {
      checkCenterAnnotation,
      count,
      countTotalVideo,
      handleChangeVideos,
      handleCreateAnnotation,
      handleImportAnnotation,
      handleUpdateAnnotation,
      listVideosObjects,
      loading,
      notesProps,
      totalCountAnnotations,
      totalVideo,
      selectedAnnotation,
      videoSelected
    } = this.props;
    const {
      annotationByTemplate,
      anchorEl,
      openMenuByTemplate,
      anchorElExport,
      anchorElImport,
      anchorElVideos,
      isTimeEditor,
      presentPlay,
      openModalGeomotion,
      openModalGeomotionPublic,
      timePresent,
      openModalProfile,
      openMenuOneByGPS,
      openMenuAllbyGPS
    } = this.state;
    const {
      interval,
      showStreetView,
      centerNotes,
      showGeomotion,
      showGeomotionPublic
    } = notesProps;
    const { geomotionVideoLinkAPI } = Meteor.settings.public;
    const videoName = isEmpty(videoSelected) ? '' : videoSelected.name;
    const videoID = videoOps.getId(videoSelected);
    const isPublicVideo = videoOps.isShared(videoSelected);
    const projectID = videoOps.getProject(videoSelected);
    const { coordinates } = !isEmpty(selectedAnnotation) ? selectedAnnotation.geoJSON.geometry : [];
    const txtIntervalAnnotation = isTimeEditor ? interval.value.toString() : timePresent.toString();
    const isVideoLine = videoSelected.coordinatesDataType !== VIDEO_COORDINATE_DATA_TYPES.POINT;

    const openMenu = Boolean(anchorEl);
    const openMenuExport = Boolean(anchorElExport);
    const openMenuVideos = Boolean(anchorElVideos);
    const openMenuImport = Boolean(anchorElImport);

    const videoProfile = find(notesProps.entWine, ['videoId', videoID]);

    if (loading) return <Loading />;
    return (
      <>
        {isEmpty(videoSelected) ? (
          <Table size="small" aria-label="a dense table">
            <TableContent
              isTableEmpty={isEmpty(videoSelected)}
              numberOfColumns={1}
              itemName="videos"
            />
          </Table>
        ) : (
          <Paper>
            <TableContainer component={Paper}>
              <Table aria-label="customized table" size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <Tooltip title="Videos" placement="top-start">
                        <IconButton
                          aria-label="comments"
                          onClick={this.handleMenuVideos}
                          style={{ color: 'white' }}
                        >
                          <SwitchVideoIcon />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        open={openMenuVideos}
                        anchorEl={anchorElVideos}
                        onClose={this.handleCloseMenuVideos}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right'
                        }}
                      >
                        {map(listVideosObjects, (element, index) => {
                          return (
                            <MenuItem
                              autoFocus
                              selected
                              key={element._id}
                              onClick={() => {
                                this.handleCloseMenuVideos();
                                handleChangeVideos(element, index + 1);
                              }}
                            >{`${videoOps.getName(element)}`}</MenuItem>
                          );
                        })}
                      </Menu>
                    </StyledTableCell>
                    <StyledTableCell align="left">{`${countTotalVideo}/${totalVideo}`}</StyledTableCell>
                    <StyledTableCell align="right" style={{ width: '100%' }}>
                      <Stack
                        color="inherit"
                        size="large"
                        direction="row"
                        justifyContent="flex-end"
                        alignitems="right"
                        spacing={0}
                      >
                        {interval.show &&
                          !isEmpty(selectedAnnotation) &&
                          (!presentPlay ? (
                            <>
                              <TextField
                                type="number"
                                variant="standard"
                                onChange={this.handleTimePresentation}
                                placeholder={txtIntervalAnnotation}
                                color="primary"
                                InputProps={{
                                  inputProps: { min: 0 },
                                  style: { color: 'white', width: '40px' }
                                }}
                              />
                              <Tooltip title="Iniciar Carrousel" placement="top-start">
                                <IconButton aria-label="comments" onClick={this.playPresentation}>
                                  <PlayCircleOutlineRoundedIcon style={{ color: 'white' }} />
                                </IconButton>
                              </Tooltip>
                            </>
                          ) : (
                            <Tooltip title="Pausar Carrousel" placement="top-start">
                              <IconButton aria-label="comments" onClick={this.playPresentation}>
                                <PauseCircleOutlineRoundedIcon style={{ color: 'white' }} />
                              </IconButton>
                            </Tooltip>
                          ))}
                        {showStreetView && !isEmpty(selectedAnnotation) && (
                          <Tooltip title="StreetView Google" placement="top-start">
                            <IconButton
                              label="StreetView"
                              aria-label="comments"
                              href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${coordinates[1]},${coordinates[0]}`}
                              target="blank"
                            >
                              <StreetviewIcon style={{ color: 'white' }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {centerNotes && (
                          <Tooltip title="Ver localización" placement="top-start">
                            <Switch
                              checked={checkCenterAnnotation}
                              icon={<PlaceIcon />}
                              onChange={this.handleCenterCheck}
                              label="Center Annotations"
                              color="primary"
                            />
                          </Tooltip>
                        )}
                        {showGeomotion && (
                          <Tooltip title="Geomotion" placement="top-start">
                            <IconButton aria-label="comments" onClick={this.handleOpenGeomotion}>
                              <PublicOffIcon style={{ color: 'white' }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {isPublicVideo && showGeomotionPublic && (
                          <Tooltip title="Geomotion Público" placement="top-start">
                            <IconButton
                              aria-label="comments"
                              onClick={this.handleOpenGeomotionPublic}
                            >
                              <PublicIcon style={{ color: 'white' }} />
                            </IconButton>
                          </Tooltip>
                        )}

                        {!isEmpty(videoSelected) && (
                          <Box>
                            <Tooltip title="Opciones de anotación" placement="top-start">
                              <IconButton aria-label="comments" onClick={this.handleMenuSettings}>
                                <SettingsIcon style={{ color: 'white' }} />
                              </IconButton>
                            </Tooltip>
                            <Menu
                              open={openMenu}
                              anchorEl={anchorEl}
                              onClose={this.handleCloseSettings}
                            >
                              <MenuItem onClick={handleUpdateAnnotation}>Editar Anotación</MenuItem>
                              <MenuItem onClick={this.handleHardRemove}>
                                Borrar todas las anotaciones
                              </MenuItem>
                              <MenuItem onClick={event => this.handleMenuImport(event)}>
                                Importar
                              </MenuItem>
                              <Menu
                                open={openMenuImport}
                                anchorEl={anchorElImport}
                                onClose={this.handleCloseSettingsImport}
                                anchorOrigin={{
                                  vertical: 'top',
                                  horizontal: 'right'
                                }}
                              >
                                <MenuItem>
                                  <InputLabel
                                    id="inputlabel"
                                    htmlFor="import"
                                    style={{ color: 'black' }}
                                  >
                                    Importar Anotaciones
                                    <input
                                      id="import"
                                      name="import"
                                      type="file"
                                      hidden
                                      onChange={event => {
                                        handleImportAnnotation(event, 'annotations');
                                      }}
                                    />
                                  </InputLabel>
                                </MenuItem>
                                <MenuItem>
                                  <InputLabel
                                    id="inputlabelJson"
                                    htmlFor="importJson"
                                    style={{ color: 'black' }}
                                  >
                                    Importar JSON
                                    <input
                                      id="importJson"
                                      name="importJson"
                                      type="file"
                                      hidden
                                      onChange={event => {
                                        handleImportAnnotation(event, 'json');
                                      }}
                                    />
                                  </InputLabel>
                                </MenuItem>
                              </Menu>
                              <MenuItem onClick={event => this.handleMenuExport(event)}>
                                Exportar
                              </MenuItem>
                            </Menu>
                            <Menu
                              open={openMenuExport}
                              anchorEl={anchorElExport}
                              onClose={this.handleCloseSettingsExport}
                              anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                              }}
                            >
                              <MenuItem
                                onClick={
                                  !openMenuOneByGPS
                                    ? () => this.handleMenuOneByGPS(true)
                                    : () => this.handleMenuOneByGPS(false)
                                }
                              >
                                Anotación actual
                                {!openMenuOneByGPS ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                              </MenuItem>
                              {openMenuOneByGPS && (
                                <MenuItem
                                  style={{ paddingLeft: '10%' }}
                                  onClick={() => {
                                    this.handleExport(videoSelected, 'actualAnnotation');
                                  }}
                                >
                                  Exportar sin tiempo GPS
                                </MenuItem>
                              )}
                              {openMenuOneByGPS && (
                                <MenuItem
                                  style={{ paddingLeft: '10%' }}
                                  onClick={() => {
                                    this.handleExport(videoSelected, 'actualAnnotation', true);
                                  }}
                                >
                                  Exportar con tiempo GPS
                                </MenuItem>
                              )}
                              <MenuItem
                                onClick={
                                  !openMenuAllbyGPS
                                    ? () => this.handleMenuAllByGPS(true)
                                    : () => this.handleMenuAllByGPS(false)
                                }
                              >
                                Todas las anotaciones
                                {!openMenuAllbyGPS ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                              </MenuItem>
                              {openMenuAllbyGPS && (
                                <MenuItem
                                  style={{ paddingLeft: '10%' }}
                                  onClick={() => {
                                    this.handleExport(videoSelected, 'annotations');
                                  }}
                                >
                                  Exportar sin tiempo GPS
                                </MenuItem>
                              )}
                              {openMenuAllbyGPS && (
                                <MenuItem
                                  style={{ paddingLeft: '10%' }}
                                  onClick={() => {
                                    this.handleExport(videoSelected, 'annotations', true);
                                  }}
                                >
                                  Exportar con tiempo GPS
                                </MenuItem>
                              )}
                              <MenuItem
                                onClick={
                                  !openMenuByTemplate
                                    ? () => this.handleMenuByTemplate(true)
                                    : () => this.handleMenuByTemplate(false)
                                }
                              >
                                Anotaciones por plantillas
                                {!openMenuByTemplate ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                              </MenuItem>
                              {openMenuByTemplate && (
                                <Box>
                                  {annotationByTemplate.map(element => {
                                    return (
                                      <MenuItem
                                        key={element}
                                        style={{ paddingLeft: '10%' }}
                                        onClick={() => {
                                          this.handleExport(videoSelected, element);
                                        }}
                                      >{`${element}`}</MenuItem>
                                    );
                                  })}
                                </Box>
                              )}
                              <MenuItem
                                onClick={() => {
                                  this.handleExport(videoSelected, 'video');
                                }}
                              >
                                Video
                              </MenuItem>
                            </Menu>
                          </Box>
                        )}
                        {!isEmpty(videoSelected) && (
                          <Tooltip title="Crear Anotaciones" placement="top-start">
                            <IconButton aria-label="comments" onClick={handleCreateAnnotation}>
                              <NoteAddIcon style={{ color: 'white' }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {!isEmpty(videoSelected) && isVideoLine && !isEmpty(videoProfile) && (
                          <Tooltip title="Ver Perfil" placement="top-start">
                            <IconButton aria-label="comments" onClick={this.handleOpenProfile}>
                              <ShowChartIcon style={{ color: 'white' }} />
                            </IconButton>
                          </Tooltip>
                        )}

                        <Modal
                          open={openModalGeomotion}
                          onClose={this.handleOpenGeomotion}
                          style={{
                            bgcolor: 'white'
                          }}
                        >
                          <Box backgroundColor="white" width="100%" height="100%">
                            <Button
                              color="success"
                              variant="outlined"
                              onClick={this.handleOpenGeomotion}
                            >
                              Close
                            </Button>
                            <iframe
                              title="geomotion"
                              src={`${geomotionVideoLinkAPI}/projects/${projectID}/videos/${videoID}`}
                              width="100%"
                              height="95%"
                            />
                          </Box>
                        </Modal>
                        <Modal
                          open={openModalGeomotionPublic}
                          onClose={this.handleOpenGeomotionPublic}
                          style={{
                            bgcolor: 'white'
                          }}
                        >
                          <Box backgroundColor="white" width="100%" height="100%">
                            <Button
                              color="success"
                              variant="outlined"
                              onClick={this.handleOpenGeomotionPublic}
                            >
                              Close
                            </Button>
                            <iframe
                              title="geomotion"
                              src={`${geomotionVideoLinkAPI}/shared/videos/${videoID}`}
                              width="100%"
                              height="95%"
                            />
                          </Box>
                        </Modal>
                        <Modal
                          open={openModalProfile}
                          onClose={this.handleCloseProfile}
                          style={{
                            bgcolor: 'white'
                          }}
                        >
                          <Box backgroundColor="white" width="100%" height="100%">
                            <Button
                              color="success"
                              variant="outlined"
                              onClick={this.handleCloseProfile}
                            >
                              Close
                            </Button>
                            <iframe
                              title="profile"
                              src={!isEmpty(videoProfile) ? videoProfile.path : ''}
                              width="100%"
                              height="95%"
                            />
                          </Box>
                        </Modal>
                      </Stack>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
              </Table>
              <Table aria-label="customized table" size="small" stickyHeader>
                <TableBody>
                  <StyledTableRow
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    directon="row"
                    key={videoName}
                  >
                    <StyledTableCell align="left">
                      <Stack
                        color="inherit"
                        size="small"
                        direction="row"
                        justifycontent="flex-start"
                        alignitems="left"
                        spacing={0}
                      >
                        {count !== 0 && totalCountAnnotations !== 0 && (
                          <>
                            <Tooltip title="Primera anotación">
                              <IconButton
                                disabled={presentPlay}
                                aria-label="comments"
                                onClick={this.handleStartAnnotation}
                              >
                                <KeyboardDoubleArrowLeftIcon />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Anotación anterior">
                              <IconButton
                                aria-label="comments"
                                disabled={presentPlay}
                                onClick={this.handleAnnotationLeft}
                              >
                                <KeyboardArrowLeftIcon />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                      </Stack>
                    </StyledTableCell>
                    <StyledTableCell
                      justifcontent="center"
                      align="center"
                      style={{ width: '100%' }}
                    >
                      {totalCountAnnotations === 0
                        ? `${videoName} ${count} / ${totalCountAnnotations}`
                        : `${videoName} ${count + 1} / ${totalCountAnnotations}`}
                    </StyledTableCell>

                    <StyledTableCell align="right">
                      <Stack
                        color="inherit"
                        size="small"
                        direction="row"
                        justifyContent="flex-end"
                        alignitems="right"
                        spacing={0}
                      >
                        {count !== totalCountAnnotations - 1 && totalCountAnnotations !== 0 && (
                          <>
                            <Tooltip title="Siguiente anotación">
                              <IconButton
                                disabled={presentPlay}
                                aria-label="comments"
                                onClick={this.handleAnnotationRight}
                              >
                                <KeyboardArrowRightIcon />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Última anotación">
                              <IconButton
                                disabled={presentPlay}
                                aria-label="comments"
                                onClick={this.handleEndAnnotation}
                              >
                                <KeyboardDoubleArrowRightIcon />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                      </Stack>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </>
    );
  }
}

AnnotationsMapsTable.defaultProps = {
  annotations: [],
  checkCenterAnnotation: false,
  countTotalVideo: 0,
  notesProps: {},
  totalCountAnnotations: 0,
  totalVideo: 0,
  videoSelected: {}
};

AnnotationsMapsTable.propTypes = {
  annotations: PropTypes.array,
  checkCenterAnnotation: PropTypes.bool,
  count: PropTypes.number.isRequired,
  countTotalVideo: PropTypes.number,
  handleChangeVideos: PropTypes.func.isRequired,
  handleSelectAnnotation: PropTypes.func.isRequired,
  handleCreateAnnotation: PropTypes.func.isRequired,
  handleImportAnnotation: PropTypes.func.isRequired,
  handleManyDeleteAnnotations: PropTypes.func.isRequired,
  handleUpdateAnnotation: PropTypes.func.isRequired,
  listVideosObjects: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  notesProps: PropTypes.object,
  selectedAnnotation: PropTypes.object.isRequired,
  totalCountAnnotations: PropTypes.number,
  totalVideo: PropTypes.number,
  videoSelected: PropTypes.object
};

export default AnnotationsMapsTable;
